@if (msgVisible()) {
  <div class="message-wrapper">
    <div [ngClass]="msgClasses()" class="message-container flex">
      <div>
        {{ message() }}
      </div>
      @if (showCloseButton()) {
        <div class="ml-auto p-2">
          <button
            (click)="closeMessage()"
            aria-label="Close Message"
            class="text-3xl cursor-pointer"
          >
            &times;
          </button>
        </div>
      }
    </div>
  </div>
}
